// extracted by mini-css-extract-plugin
export default {"page-header":"style_page-header__OJj1h"};